// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__4fyeo","content":"LoadingAlert_content__3BBDv"};